export default __webpack_public_path__ + "static/calendar-mock-2-78cdedbf8254fa316bccca05c30148f4.svg";